// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero-module--wrapper--2FKkM","one":"hero-module--one--UnlPJ","dotsix":"hero-module--dotsix--2VQle"};